<template>
  <v-data-table :headers="headers" :items="importedFiles" class="elevation-0">
    <template v-slot:items="props">
      <td class="text-xs-left">{{ props.item.file_name }}</td>
      <td class="text-xs-left">{{ props.item.created_at | moment("DD/MM/YYYY")}}</td>
      <td class="text-xs-left">
        <v-icon
          small
          @click="downloadFile(props.item.file_path)"
          class="miniPrimary pr-1 mr-2"
        >cloud_download</v-icon>
        <a
          class="caption light-blue--text text--darken-4"
          target="_blank"
          :href="props.item.path_file"
        >{{ props.item.fileName }}</a>
        <!-- <v-icon small class="mx-2" @click="editItem(props.item.id)">edit</v-icon> -->
        <v-icon small class="mx-0" @click="confirmDelGeneralFiles(props.item)" v-if="!viewForm">delete</v-icon>
      </td>
    </template>
  </v-data-table>
</template>

<script>
export default {
  name: "GeneralFiles",
  
  props: {
    importedFiles: Array,
    confirmDelGeneralFiles: Function,
    editItem: Function,
    viewForm: Boolean
  },

  data() {
    return {
      headers: [
        {
          text: "Nome do arquivo",
          align: "left",
          sortable: true,
          value: "file_name",
        },
        {
          text: "Data do anexo",
          value: "created_at",
          align: "left",
          sortable: true,
        },
        {
          text: "Ações",
          align: "left",
          value: "path_file",
          sortable: false,
        },
      ],
    };
  },

  methods: {
    downloadFile(path) {
      let baseURL =
        process.env.NODE_ENV === "production"
          ? process.env.VUE_APP_API_URL
          : process.env.VUE_APP_API_URL_DEV;

      baseURL;
      window.open(`${baseURL}/storage/${path}`);
    },
  },
};
</script>

<style>
</style>